import NewEmployee from './NewEmployee';
export default NewEmployee;
